import { Container, Row, Col, Card } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";
import CodeCopyButton from "../Components/CodeCopyButton";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import prism from 'react-syntax-highlighter/dist/esm/styles/prism/prism';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {Resource} from "../Components/Resource";
import Accordion from 'react-bootstrap/Accordion';

//import docco from 'react-syntax-highlighter/dist/esm/styles/hljs/docco';

//SyntaxHighlighter.registerLanguage('javascript', js);
//SyntaxHighlighter.registerLanguage('jsx', jsx);
//SyntaxHighlighter.registerLanguage('bash', bash);

const Instructions = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const col1 = 4;
  const col2 = 8;
  return !authState?.isAuthenticated ? (
    <Container>
        <Row>
        <Col className="text-center">
            <Card style={{ margin: "1em auto", height: "160px" }}>
                <Card.Header>Unauthorized. 401</Card.Header>
                <Card.Body>
                    You are not authorized to view this content. Please log in for access.
                </Card.Body>
            </Card>
        </Col>
      </Row>
    </Container>
  ) : (
    <>
    <Container fluid style={{marginTop:"2em"}}>

      <Row>
        <Col lg={col1}>
          <h2>Dev Instructions</h2>
        </Col>
        <Col lg={col2}>
          <p>Abbreviated instructions for use of Okta authentication for React App</p>
          <h5>Sources</h5>
          <table className="table">
            <thead></thead>
            <tbody>
              <tr>
                <td><strong>okta Dev QuickStart for React</strong></td>
                <td>Uses React classes. Some of the referenced dependencies in this are out of date.</td>
                <td><a href="https://developer.okta.com/docs/guides/sign-into-spa-redirect/react/main/" target="_blank" rel="noreferrer" title="okta Developer QuickStart">https://developer.okta.com/docs/guides/sign-into-spa-redirect/react/main/</a></td>
              </tr>
              <tr>
                <td><strong>Build a Secure SPA with React Routing</strong></td>
                <td>Uses React Hooks. But uses wouter instead of react-router-dom</td>
                <td><a href="https://developer.okta.com/blog/2021/11/01/react-routing" target="_blank" rel="noreferrer" title="Build a Secure SPA with React Routing">https://developer.okta.com/blog/2021/11/01/react-routing</a></td>
              </tr>
            </tbody>

          </table>
          <p>These instructions take elements from both sources to use React hooks and react-router-dom.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Setup</h3>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">1. Install Packages</h5>
          <CodeCopyButton>{Resource.npmInstall}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="bash" style={prism}>{Resource.npmInstall}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">2. Add file: .env</h5>
          <p className="instruction-step">To root folder</p>
          <CodeCopyButton>{Resource.env}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter style={prism}>{Resource.env}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">3. Add file: .env.development.local</h5>
          <p className="instruction-step">To root folder; forces HTTPS and PORT</p>
          <CodeCopyButton>{Resource.devenv}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter style={prism}>{Resource.devenv}</SyntaxHighlighter>
        </Col>
      </Row>



      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>App Compoent - Complete Code</Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col lg={col1} className="allow-code-copy">
                <h5 className="instruction-step">4. Add Code to App.js</h5>
                <p className="instruction-step">
                  the code is broken into parts below for faster copy/paste
                  <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                  Set up okta variables from .env
                  <br/><br/><br/><br/><br/>
                  New instance of oktaAuth
                  <br/><br/><br/><br/><br/><br/><br/><br/>
                  <br/><br/>
                  Add history an restoreOriginalUri to App before return, has to be inside of BrowserRouter
                  <br/><br/><br/><br/>
                  Security Component wraps App
                  <br/><br/><br/><br/><br/><br/><br/>
                  Add Route for callback location
                  </p>
                <CodeCopyButton>{Resource.appContent}</CodeCopyButton>
              </Col>
              <Col lg={col2}>
                <SyntaxHighlighter language="javascript" style={prism}>{Resource.appContent}</SyntaxHighlighter>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>App Component - Cody By Parts</Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col lg={col1} className="allow-code-copy">
                <h5 className="instruction-step">4. Add Code to App.js</h5>
                <p className="instruction-step">a{")"} import</p>
                <CodeCopyButton>{Resource.setupImport}</CodeCopyButton>
              </Col>
              <Col lg={col2}>
                <SyntaxHighlighter language="javascript" style={prism}>{Resource.setupImport}</SyntaxHighlighter>
              </Col>
            </Row>
            <Row>
              <Col lg={col1} className="allow-code-copy">
                <p className="instruction-step">b{")"} Outside of App Component</p>
                <CodeCopyButton>{Resource.setupOkta}</CodeCopyButton>
              </Col>
              <Col lg={col2}>
                <SyntaxHighlighter language="javascript" style={prism}>{Resource.setupOkta}</SyntaxHighlighter>
              </Col>
            </Row>
            <Row>
              <Col lg={col1} className="allow-code-copy">
                <p className="instruction-step">c{")"} In App, above return. I received an error when BrowserRouter came after this. I have BrowserRouter wrapping App in Index.js</p>
                <CodeCopyButton>{Resource.setupAppTopLevel}</CodeCopyButton>
              </Col>
              <Col lg={col2}>
                <SyntaxHighlighter language="javascript" style={prism}>{Resource.setupAppTopLevel}</SyntaxHighlighter>
              </Col>
            </Row>
            <Row>
              <Col lg={col1} className="allow-code-copy">
                <p className="instruction-step">d{")"} Wrap app JSX and include route for callback</p>
                <CodeCopyButton>{Resource.setupAppReturn}</CodeCopyButton>
              </Col>
              <Col lg={col2}>
                <SyntaxHighlighter language="jsx" style={prism}>{Resource.setupAppReturn}</SyntaxHighlighter>
              </Col>
            </Row>

          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <br/><br/>
      <Row>
        <Col>
          <h3>Use Instructions</h3>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">Log In Button</h5>
          <p className="instruction-step">
            <br/><br/><br/>
            Import Statement
            <br/><br/><br/>
            Call Hook
            <br/><br/><br/><br/><br/><br/><br/><br/>
            authState?.isAuthenticated is the primary way to manage content via any type of conditional
            <br/><br/><br/>
            Log In/Out Calls
          </p>
          <CodeCopyButton>{Resource.button}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="jsx" style={prism}>{Resource.button}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">Force Login</h5>
          <p className="instruction-step">
          <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
          Using the same call as the button, force login
          </p>
          <CodeCopyButton>{Resource.forcelogin}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="jsx" style={prism}>{Resource.forcelogin}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">Redirect</h5>
          <p className="instruction-step">
          <br/><br/><br/><br/>
          No difference w/ okta use, just domentation of Navigate component
          </p>
          <CodeCopyButton>{Resource.redirect}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="jsx" style={prism}>{Resource.redirect}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">Profile Info</h5>
          <p className="instruction-step"></p>
          <CodeCopyButton>{Resource.profile}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="jsx" style={prism}>{Resource.profile}</SyntaxHighlighter>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Using Authenticated API Endpoints</h3>
        </Col>
      </Row>
      <Row>
        <Col lg={col1} className="allow-code-copy">
          <h5 className="instruction-step">Add Bearer token to header</h5>
          <p className="instruction-step"></p>
          <CodeCopyButton>{Resource.useAPI}</CodeCopyButton>
        </Col>
        <Col lg={col2}>
          <SyntaxHighlighter language="jsx" style={prism}>{Resource.useAPI}</SyntaxHighlighter>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default Instructions;